if (!customElements.get('newsletter-modal')) {
  const STORAGE_KEY = 'cybirdy_newsletter_modal_shown';
  const VISIT_KEY = 'cybirdy_page_visit_count';
  const BODY_CLASS = 'newsletter-modal-open';

  class NewsletterModal extends ModalDialog {
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);

      if (this.dataset.suppress === 'true') return;

      if (this.dataset.subscribed === 'true') {
        this.markShown();
        this.show();
        return;
      }

      if (this.dataset.showOnLoad === 'true' || window.location.hash === '#newsletter-modal') {
        this.show();
        return;
      }

      if (this.hasBeenShown()) return;

      this.visitCount = this.incrementVisitCount();
      this.setupTriggers();
    }

    show(opener) {
      super.show(opener);
      document.body.classList.add(BODY_CLASS);
    }

    hide() {
      super.hide();
      document.body.classList.remove(BODY_CLASS);
      this.removeTriggers();

      if (window.location.hash === '#newsletter-modal') {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }

    hasBeenShown() {
      try {
        return localStorage.getItem(STORAGE_KEY) === '1';
      } catch (error) {
        return false;
      }
    }

    markShown() {
      try {
        localStorage.setItem(STORAGE_KEY, '1');
      } catch (error) {
        /* ignore storage errors */
      }
      this.removeTriggers();
    }

    incrementVisitCount() {
      try {
        const count = parseInt(localStorage.getItem(VISIT_KEY) || '0', 10) + 1;
        localStorage.setItem(VISIT_KEY, String(count));
        return count;
      } catch (error) {
        return 1;
      }
    }

    setupTriggers() {
      if (this.visitCount >= 3) {
        this.thirdVisitTimeout = window.setTimeout(() => this.tryShow(), 1500);
      }

      this.onMouseOut = (event) => {
        if (event.relatedTarget || event.clientY > 0) return;
        this.tryShow();
      };

      document.documentElement.addEventListener('mouseout', this.onMouseOut);
    }

    removeTriggers() {
      if (this.thirdVisitTimeout) {
        window.clearTimeout(this.thirdVisitTimeout);
        this.thirdVisitTimeout = null;
      }

      if (this.onMouseOut) {
        document.documentElement.removeEventListener('mouseout', this.onMouseOut);
        this.onMouseOut = null;
      }
    }

    tryShow() {
      if (this.hasAttribute('open') || this.hasBeenShown()) return;
      this.markShown();
      this.show();
    }
  }

  customElements.define('newsletter-modal', NewsletterModal);
}
